import React from 'react'
import styles from './DropDownV2.module.css'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { useTranslation } from "react-i18next";

const DropDownV2 = (props) => {//props=[nowSelected,setSettings,settingType,settingName,items,label]
    //translations
    const t = useTranslation('common').t;

    let dropDownListItems = undefined
    if (props.items && props.onSelect) {
        dropDownListItems = props.items.map((item, i) => <Dropdown.Item key={i} onClick={() => props.onSelect(item)} className={styles.specificSettingsDropDownItem}>{t(item.key || item.name || props.defaultSelectedItemName)}</Dropdown.Item>)
    }
    return (
        <div className={styles.someSettingDiv}>
            <span className={styles.specificSettingsText}>{t(props.label)} </span>
            <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={t(props.nowSelected?.key || props.nowSelected?.name || props.defaultSelectedItemName)}>
                {dropDownListItems}
            </DropdownButton>
        </div>
    )
}

export default DropDownV2